<script setup lang="ts">
import { useAttrs } from 'vue';

export interface KaDescriptionProps {
  description?: string;
  hideDescription?: boolean;
}

const props = withDefaults(defineProps<KaDescriptionProps>(), {
  description: undefined,
  hideDescription: false,
});

const attrs = useAttrs();
const dataTestid = (attrs['data-testid'] as string) || (attrs.id as string);
</script>
<template>
  <p
    :data-testid="dataTestid"
    :class="['text-sm text-gray-600 dark:text-gray-400', { 'sr-only': props.hideDescription }]"
  >
    <slot v-bind="{ description: props.description }">
      {{ props.description }}
    </slot>
  </p>
</template>
